"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var init_1 = require("./init");
var isProd = process.env.NODE_ENV === 'production';
(0, init_1.eventLib)(window[process.env.EVT_APP_CONFIG], isProd, process.env.EVT_EXPOSED_VAR);
